'use client'

import { useProductCountsQuery } from '@repo/web-ui/hooks/use-site-data'
import { useTranslations } from 'next-intl'

const loadingNumber = (
  <div className="inline-block h-[15px] w-[40px] animate-pulse rounded bg-gray-800" />
)

export function ProductCounts() {
  const { data: productCounts } = useProductCountsQuery()
  const t = useTranslations('pages.promo.yearly')

  return (
    <>
      {([1, 2, 3, 4, 5] as const).map(item => (
        <li key={`reason_1_${item}`} className="pb-[30px] md:pb-3">
          {t.rich(`1.reason.bullet.${item}`, {
            b: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
            fonts: () =>
              productCounts?.fonts ? (
                <strong>{productCounts.fonts.toLocaleString()}</strong>
              ) : (
                loadingNumber
              ),
            graphics: () =>
              productCounts?.graphics ? (
                <strong>{productCounts.graphics.toLocaleString()}</strong>
              ) : (
                loadingNumber
              ),
            embroidery: () =>
              productCounts?.embroidery ? (
                <strong>{productCounts.embroidery.toLocaleString()}</strong>
              ) : (
                loadingNumber
              ),
            crafts: () =>
              productCounts?.crafts ? (
                <strong>{productCounts.crafts.toLocaleString()}</strong>
              ) : (
                loadingNumber
              ),
          })}
        </li>
      ))}
    </>
  )
}
